module.exports = __webpack_public_path__ + "static/media/google.25ff2df9.svg";